import {useTranslation} from "react-i18next";
import {TableColumnData} from "../../../../../types/common";
import React, {useCallback} from "react";
import {useNewWindow, useTimeConverter} from "../../../../../hooks/hooks";
import {CounselorCouponVoucherListVO, CounselorVoucherStatus} from "../../../../../types/counselor";
import {RedActionButton} from "../../../../../components/Buttons";
import {UserCounselorStatusConverter} from "../counselor_voucher/UserCounselorStatusConverter";
import listStyle from "../../../../../layout/content/list/list.module.scss";
import moment from "moment/moment";

interface Props {
    userIdx: number;
    name: string;
    getList: () => void;
}
export function useCounselorVoucherInfoColumns({userIdx, name, getList}:Props) {
    const {t} = useTranslation("user");
    const {timeConverter} = useTimeConverter();
    const {openNewWindowWithURL, openCollectProduct} = useNewWindow();
    const isOutOfDate = useCallback((availableUntil: string) => moment.utc(availableUntil).isBefore(moment()), []);

    const isPurchasedVoucher = (orderIdx: number) => {
        return orderIdx !== null
    };

    // 주문 상세
    const handleOrderDetail = (orderIdx: number) => {
        openNewWindowWithURL(
            // eslint-disable-next-line max-len
            `/detail/order/${orderIdx}`,
            {
                width: 1000,
                height: 800,
            }
        )
    }

    // 회수
    const handleRevokeVoucher = (voucherIdx: number) => {
        openCollectProduct(
            {
                userIdx,
                userName: name,
                voucherIdx: voucherIdx,
            },
            () => {
                getList();
            }
        );
    }

    const columns: TableColumnData<CounselorCouponVoucherListVO>[] = [
        {
            accessor: "createAt",
            header: t("detail.counselorVoucher.infoListPanel.createAt"),
            sortable: true,
            getNode: (a) => <span>{timeConverter.convertToLocalTime(a.createAt)}</span>,
        },
        {
            accessor: "availableUntil",
            header: t("detail.counselorVoucher.infoListPanel.availableUntil"),
            sortable: true,
            getNode: (a) => <span>{timeConverter.convertToLocalTime(a.availableUntil)}</span>,
        },
        {
            accessor: "issuerOrganName",
            header: t("detail.counselorVoucher.infoListPanel.issuer"),
            sortable: false,
            getNode: (a) =>
                <>
                    {isPurchasedVoucher(a.orderIdx)
                        ? (<span className={isPurchasedVoucher(a.orderIdx) ? listStyle.underline : ""}
                              onClick={() => handleOrderDetail(a.orderIdx)}>결제</span>)
                        : (<>-</>)}
                </>,
        },
        {
            accessor: "unitVoucherStatus",
            header: t("detail.counselorVoucher.infoListPanel.status"),
            sortable: false,
            getNode: (a) => {
                const isExpired = a.unitVoucherStatus === CounselorVoucherStatus.USABLE && isOutOfDate(a.availableUntil);
                const displayStatus = isExpired ? CounselorVoucherStatus.EXPIRED : a.unitVoucherStatus;

                return (
                    <>
                        <UserCounselorStatusConverter  status={displayStatus} />
                    </>
                );
            },
        },
        {
            accessor: "collectReason",
            header: t("detail.counselorVoucher.infoListPanel.reason"),
            sortable: false,
            getNode: (a) => <span>{a.collectReason}</span>,
        },
        {
            accessor: "idx",
            header: "",
            sortable: false,
            getNode: (a) => {
                // todo 회수 할수있는 조건으로 수정해야함
                if (a.unitVoucherStatus === CounselorVoucherStatus.USABLE) {
                    return (
                        <RedActionButton onClick={() => handleRevokeVoucher(a.idx)}>
                            {t("detail.counselorVoucher.infoListPanel.revoke")}
                        </RedActionButton>
                    );
                } else {
                    return <></>;
                }
            },
            width: 65,
        },
    ];

    return {
        columns
    }
}
